/**
 * @generated SignedSource<<6b6aa7837cc8110ae0bb3722f5976e10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameUk",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "details",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailsUk",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationUk",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homeCardsComponentsServiceByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Service",
        "kind": "LinkedField",
        "name": "serviceById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Endpoint",
            "kind": "LinkedField",
            "name": "endpoints",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "homeCardComponents_endpoint"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "homeCardComponents_serviceById"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "homeMerchantActionsComponents_serviceById"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homeCardsComponentsServiceByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Service",
        "kind": "LinkedField",
        "name": "serviceById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Endpoint",
            "kind": "LinkedField",
            "name": "endpoints",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be548ec598820d2f0b7042d08f86f12c",
    "id": null,
    "metadata": {},
    "name": "homeCardsComponentsServiceByIdQuery",
    "operationKind": "query",
    "text": "query homeCardsComponentsServiceByIdQuery(\n  $id: String\n) {\n  serviceById(id: $id) {\n    id\n    version\n    name\n    nameUk\n    details\n    detailsUk\n    location\n    locationUk\n    tags\n    endpoints {\n      id\n      tags\n      quantity\n      end\n      ...homeCardComponents_endpoint\n    }\n    ...homeCardComponents_serviceById\n    ...homeMerchantActionsComponents_serviceById\n  }\n}\n\nfragment endpointComponents_endpoint on Endpoint {\n  id\n  name\n  nameUk\n  details\n  detailsUk\n  quantity\n  price\n  tags\n  ...endpointCountComponents_endpoint\n}\n\nfragment endpointComponents_serviceById on Service {\n  id\n  ...endpointCountComponents_serviceById\n}\n\nfragment endpointCountComponents_endpoint on Endpoint {\n  id\n}\n\nfragment endpointCountComponents_serviceById on Service {\n  id\n}\n\nfragment homeCardComponents_endpoint on Endpoint {\n  id\n  name\n  nameUk\n  details\n  detailsUk\n  quantity\n  price\n  end\n  tags\n  ...endpointComponents_endpoint\n}\n\nfragment homeCardComponents_serviceById on Service {\n  id\n  ...endpointComponents_serviceById\n}\n\nfragment homeMerchantActionsComponents_serviceById on Service {\n  id\n  merchant {\n    id\n  }\n  description\n  tags\n  version\n}\n"
  }
};
})();

node.hash = "67a32e5f6fa6bca3d91f131897e335c2";

module.exports = node;
